<template>
	<div class="pt-6 px-6 pb-6">
		<div class="space-y-4">
			<h1 class="text-4xl mb-8 text-gray-900 font-bold">
				<span v-if="locale == 'de'">Ihre Daten wurden sicher übermittelt!</span>
				<span v-else>Your data has been submitted securely!</span>
			</h1>

			<div class="flex flex-col md:flex-row items-center gap-y-4 md:gap-x-6">
				<div v-if="locale == 'de'" class="space-y-4">
					<p>
						Es wurde Ihnen eine Bestätigungsemail an {{ user.email }} gesendet.
					</p>
					<p>
						Bitte checken Sie ob sie diese erhalten haben, das sollte innerhalb
						weniger Minuten geschehen.
					</p>
					<p>
						Sollte Sie nicht angekommen sein, fordern Sie die E-Mail erneut an
						oder wenden Sie sich an unseren
						<a href="mailto:info@cropspot.com" class="underline">support</a>.
					</p>
				</div>
				<div v-else class="space-y-4">
					<p>A confirmation email has been sent to {{ user.email }}.</p>
					<p>
						Please check if you have received this email, this should happen
						within a few minutes.
					</p>
					<p>
						If you have not received it, please request it again or contact our
						<a href="mailto:info@cropspot.com" class="underline">support</a>.
					</p>
				</div>

				<div class="flex items-end w-full md:w-auto">
					<ui-icon class="ml-auto h-12" name="ssl-logo" stroke-width="2" />
				</div>
			</div>

			<inertia-link
				:href="$route('verification.resend')"
				method="post"
				as="button"
				class="font-semibold text-orange-500"
			>
				<span v-if="locale == 'de'">E-Mail erneut anfordern</span>
				<span v-else>Resend email again</span>
			</inertia-link>

			<!-- resent confirmation banner -->
			<div class="bg-green text-green-100 p-3 flex rounded-lg" v-if="resent">
				<div class="flex items-center justify-between">
					<ui-icon name="check" class="w-8 h-8" stroke-width="2.5" />
					<p class="ml-3 font-medium text-white">
						<span v-if="locale == 'de'"
							>Die Bestätigungs-E-Mail wurde erneut gesendet!</span
						>
						<span v-else>The confirmation email has been sent again!</span>
					</p>
				</div>
			</div>

			<p v-if="locale == 'de'">
				Sollten Sie Hilfe benötigten freuen wir uns über Ihre Kontaktaufnahme
				über info@cropspot.com
			</p>
			<p v-else>
				If you need any assistance, please contact us at info@cropspot.com.
			</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		resent: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
